"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UNITS;
(function (UNITS) {
    UNITS["AMPERE"] = "AMPERE";
    UNITS["CELSIUS"] = "CELSIUS";
    UNITS["FAHRENHEIT"] = "FAHRENHEIT";
    UNITS["FOOT_POUNDS"] = "FOOT_POUNDS";
    UNITS["FOOT"] = "FOOT";
    UNITS["FOOT_PER_SECOND_SQUARED"] = "FOOT_PER_SECOND_SQUARED";
    UNITS["KILO_POUNDS"] = "KILO_POUNDS";
    UNITS["KILOGRAM"] = "KILOGRAM";
    UNITS["MILES"] = "MILES";
    UNITS["MILES_PER_HOUR"] = "MILES_PER_HOUR";
    UNITS["MILES_PER_GALLON"] = "MILES_PER_GALLON";
    UNITS["EVENTS_PER_1000_MILES"] = "EVENTS_PER_1000_MILES";
    UNITS["GAL"] = "GAL";
    UNITS["LITERS"] = "LITERS";
    UNITS["PERCENT"] = "%";
    UNITS["PERCENT_MOVING_TIME"] = "%_MOVING_TIME";
    UNITS["RADIANS_PER_SECOND"] = "rad/s";
    UNITS["RPM"] = "RPM";
    UNITS["VOLTS"] = "V";
    UNITS["HP"] = "HP";
    UNITS["POUND"] = "POUND";
    UNITS["METERS"] = "METERS";
    UNITS["METERS_PER_SECOND_SQUARED"] = "METERS_PER_SECOND_SQUARED";
    UNITS["NEWTON_METERS"] = "NEWTON_METERS";
    UNITS["KILOMETERS"] = "KILOMETERS";
    UNITS["KILOMETERS_PER_HOUR"] = "KILOMETERS_PER_HOUR";
    UNITS["KILOMETERS_PER_LITER"] = "KILOMETERS_PER_LITER";
    UNITS["EVENTS_PER_1000_KILOMETERS"] = "EVENTS_PER_1000_KILOMETERS";
    UNITS["DEGREES_PER_SECOND"] = "DEGREES_PER_SECOND";
    UNITS["KILOWATT"] = "KILOWATT";
    UNITS["KILOWATT_HOUR"] = "KILOWATT_HOUR";
    UNITS["KILOWATT_HOUR_PER_KILOMETER"] = "KILOWATT_HOUR_PER_KILOMETER";
    UNITS["KILOWATT_HOUR_PER_MILE"] = "KILOWATT_HOUR_PER_MILE";
    UNITS["KILOWATT_PER_KILOMETER"] = "KILOWATT_PER_KILOMETER";
    UNITS["KILOWATT_PER_MILE"] = "KILOWATT_PER_MILE";
    UNITS["SECONDS"] = "SECONDS";
    UNITS["EVENTS"] = "EVENTS";
    UNITS["TONS"] = "TONS";
    UNITS["FOOT_POUNDS_STRING"] = "FOOT POUNDS";
    UNITS["NEWTON_METERS_STRING"] = "NEWTON METERS";
})(UNITS || (UNITS = {}));
exports.default = UNITS;
